function listCacheClear() {
  this.__data__ = [], this.size = 0;
}
export {
  listCacheClear as default
};
//# sourceMappingURL=_listCacheClear.js.map
